export default function handleScroll(ref: any) {
  window.scrollTo({
    top: ref.offsetTop-100,
    left: 0,
    behavior: "smooth",
  });
}
